$(function() {
    const buttons = '';
});